import React from 'react'
// libs
import { reduxForm } from 'redux-form'
// components
import Grid from '@mui/material/Grid2'
import { Button } from 'components/UI'
import { ReduxInput, ReduxSelect } from 'components/FormElements'
// constants
import { Forms, KPI_RESULT_TYPE_VALUES } from 'constants/index'
// themes
import { CloseIcon } from 'components/UI/Icons'
// views
import {
  Header,
  Paper
} from 'components/Modals/PlanItems/KPI/MinimizedModal/components/DetailsSection/components/DetailsForm/components/view'
// utils
import get from 'lodash/get'
import { generateScaleOptions } from 'utils/kpi'

const SetResultRowForm = ({ hideModal, handleSubmit, entity }) => {
  const isValueExpected = get(entity, 'resultType') === KPI_RESULT_TYPE_VALUES.VALUE
  const isScaleExpected = get(entity, 'resultType') === KPI_RESULT_TYPE_VALUES.SCALE

  const scaleValue = get(entity, 'resultTypeScale', [])
  const scaleOptions = generateScaleOptions(scaleValue)

  return (
    <Paper component={'form'} onSubmit={handleSubmit} style={{ position: 'relative', zIndex: 34343434343 }}>
      <Header>
        <span>Period Result</span>
        <CloseIcon right={0} onClick={hideModal} />
      </Header>
      <Grid container minHeight={160} alignItems='center' justifyContent='center'>
        <Grid size={12}>
          {isValueExpected && <ReduxInput name={'resultValue'} label={'Result'} autoFocus />}
          {isScaleExpected && <ReduxSelect name={'resultValue'} label={'Result'} options={scaleOptions} />}
        </Grid>
        <Button shadowLess type={'submit'} disabled={!isValueExpected && !isScaleExpected}>
          Save
        </Button>
      </Grid>
    </Paper>
  )
}

export default reduxForm({
  form: Forms.KPI_SET_RESULT_ROW_FORM
})(SetResultRowForm)
